<template>
  <div v-if="idToken" class="default-color">
    <validation-observer ref="observer" v-slot="{ invalid }" tag="form">
      <b-container>
        <b-form @submit.stop.prevent="onSubmit" id="addKeyForm" ref="addKeyForm">
          <b-row>
            <b-col>
              <validation-provider name="steam key"
                                   :rules="{required: true,
                                   regex: /^(\w{5})-(\w{5})-(\w{5})-(\w{5})-(\w{5})$|^(\w{5})-(\w{5})-((\w{5}))$/}"
                                   v-slot="{errors}">
                <b-form-group id="steamKeyGroup" label="Steam Key:" label-for="steamKeyInput">
                  <b-input-group>
                    <b-form-input id="steamKeyInput" type="text" v-model="form.steamKey"/>
                    <b-input-group-append>
                      <a href="#" id="keyInfo"><img src="../assets/question.png" alt="question mark"/></a>
                    </b-input-group-append>
                  </b-input-group>
                  <span class="text-danger">{{errors[0]}}</span>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <validation-provider name="item name"
                                   :rules="{required: true}"
                                   v-slot="{errors}">
                <b-form-group id="steamNameGroup" label="Item Name:" label-for="steamNameInput">
                  <b-form-input id="steamNameInput" type="text" v-model="form.name"/>
                  <span class="text-danger">{{errors[0]}}</span>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <validation-provider name="steam app id" rules="numeric" v-slot="{errors}">
                <b-form-group id="steamAppIdGroup" label="Steam AppID(optional):" label-for="steamAppIdInput">
                  <b-form-input id="steamAppIdInput" type="text" v-model="form.steamAppId"/>
                  <span class="text-danger">{{errors[0]}}</span>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div id="keyResult" v-bind:class="{'text-danger':resultError}" v-html="resultMessage">

              </div>
            </b-col>
          </b-row>
          <div class="modal-footer bg-dark">
            <b-button class="mr-2" type="submit" variant="outline-danger">Submit</b-button>
            <b-button class="mr-2" @click="clearFields" variant="outline-danger">Clear Fields</b-button>
            <b-button variant="outline-danger" @click="closeModal">Close</b-button>
          </div>
        </b-form>
      </b-container>
    </validation-observer>

    <b-popover target="keyInfo" triggers="hover" variant="danger">
      <p>Supported Steam keys will be in one of the following formats:</p>

      <p style="font-size: small">&bull; XXXXX-XXXXX-XXXXX</p>
      <p style="font-size: small">&bull; XXXXX-XXXXX-XXXXX-XXXXX-XXXXX</p>
      <p style="font-style: italic">*X = any letter or number</p>
    </b-popover>
  </div>
  <div v-else>
    Problem loading form
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'SteamKeyAddForm',
    props: { idToken: String },
    data () {
      return {
        form: {
          steamKey: '',
          steamAppId: '',
          name: '',
          claimed: 'false'
        },
        resultError: false,
        resultMessage: ''
      }
    },
    methods: {
      closeModal () {
        this.$emit('close')
      },
      clearFields () {
        this.form.steamKey = ''
        this.form.steamAppId = ''
        this.form.name = ''
        this.resultMessage = ''
        this.resultError = false
      },
      async onSubmit (e) {
        e.preventDefault()
        this.resultMessage = ''
        this.$refs.observer.validate().then((result) => {
          if (!result) {
            return
          }
          let postData = {
            steamKey: this.form.steamKey.toUpperCase(),
            steamAppId: !this.form.steamAppId ? 0 : this.form.steamAppId,
            name: this.form.name,
            claimed: this.form.claimed
          }

          let addKeyPostRequest = {
            method: 'POST',
            url: 'https://3deddkpozj.execute-api.us-east-2.amazonaws.com/live/prod-apopkeystore/add',
            crossDomain: true,
            data: postData,
            headers: {
              'content-type': 'application/json',
              'x-apop-token': this.idToken
            }
          }

          axios(addKeyPostRequest).then(response => {
            this.resultMessage =
              'Key for \'' + this.form.name + '\' added successfully.'
          }).catch(err => {
            console.log(err.response)
            this.resultError = true
            if (err.response.data.message === 'The conditional request failed') {
              this.resultMessage =
                'The submitted Steam key already exists in our database. <br/>It may have been claimed previously.'
            } else {
              this.resultMessage =
                'An unexpected error occurred inserting the key.  <br/>Please resubmit.  If this error persists, contact the administrators.'
            }
          })
        })
      }

    }
  }
</script>
